// extracted by mini-css-extract-plugin
module.exports = {"starRating":"styles_starRating__PnG4G","totalReview":"styles_totalReview__6wQV7"};